import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable, of} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DoctorService {

  constructor(private http: HttpClient) { }
  urlEndPoint = environment.endPoint;

  getDoctors(term: string): Observable<any> {
    if (term === '' || term.length < 3) {
      return of([]);
    }
    const params = new URLSearchParams();
    params.set('term', term);
    return this.http.get<any>(this.urlEndPoint + '/api/doctors?' + params.toString());
  }
}
